import { call, put, takeLatest } from "redux-saga/effects";
import axios from "axios";
import {
  fetchSellOrdersRequest,
  fetchSellOrdersSuccess,
  fetchSellOrdersFailure,
  fetchSellOrderDetailsRequest,
  fetchSellOrderDetailsSuccess,
  fetchSellOrderDetailsFailure,
  updateSellOrderRequest,
  updateSellOrderSuccess,
  updateSellOrderFailure,
} from "./SellOrdersSlice";

function* fetchSellOrdersSaga(action) {
  try {
    const { start = 0, limit = 10, search = "", startDate ="", endDate="" } = action.payload || {};
    const response = yield call(() =>
      axios.get(
        `${
          process.env.REACT_APP_API_BASE_URL
        }/api/v1/redeem/getSellOrders?start=${start}&limit=${limit}&search=${encodeURIComponent(
          search
        )}&startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}`
      )
    );

    const resData = response.data;

    if (resData.success) {
      const ordersList = resData.data?.data || [];
      const total = resData.data?.total || 0;

      yield put(
        fetchSellOrdersSuccess({
          orders: ordersList,
          total,
          message: resData.message,
        })
      );
    } else {
      yield put(
        fetchSellOrdersFailure(resData.message || "Something went wrong")
      );
    }
  } catch (error) {
    yield put(fetchSellOrdersFailure(error.message));
  }
}

function* fetchSellOrderDetailsSaga(action) {
  try {
    const { id } = action.payload;

    const response = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/transactions/getSellOrderDetails/${id}`
      )
    );

    const resData = response.data;

    if (resData?.data) {
      yield put(fetchSellOrderDetailsSuccess(resData.data));
    } else {
      yield put(
        fetchSellOrderDetailsFailure(resData.message || "No order found")
      );
    }
  } catch (error) {
    yield put(fetchSellOrderDetailsFailure(error.message));
  }
}

function* updateSellOrderSaga(action) {
  try {
    const { transId, type, status } = action.payload;

    const response = yield call(() =>
      axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/transactions/updateSellOrder`,
        {
          transId,
          type,
          status,
        }
      )
    );

    const resData = response.data;

    if (resData.success) {
      yield put(updateSellOrderSuccess(resData.message));
    } else {
      yield put(
        updateSellOrderFailure(resData.message || "Failed to update order")
      );
    }
  } catch (error) {
    yield put(updateSellOrderFailure(error.message));
  }
}

export function* watchSellOrdersSaga() {
  yield takeLatest(fetchSellOrdersRequest.type, fetchSellOrdersSaga);
  yield takeLatest(
    fetchSellOrderDetailsRequest.type,
    fetchSellOrderDetailsSaga
  );
  yield takeLatest(updateSellOrderRequest.type, updateSellOrderSaga);
}
